import { Box, Container, Typography } from '@mui/material';
import VideoPlayerSection from '@components/VideoPlayer';
import Image from 'next/image';

import { useStyles } from './useStyles';
import useWindowDimensions from '@utils/useWindowDimensions';

interface IVideoPlayerComponent {
  slice: any;
}

const VideoPlayerComponent = ({ slice }: IVideoPlayerComponent) => {
  const { video_link, image, image_caption } = slice?.primary || {};
  const { url } = video_link || {};
  const { url: imageUrl, alt, dimensions } = image || {};
  const { height: imgHeight, width: imgWidth } = dimensions || {};

  const { width } = useWindowDimensions();

  const classes = useStyles();

  return (
    <Box className={classes.mainContainer}>
      <Container maxWidth="xl" disableGutters>
        {url ? (
          <Box className={classes.videoWrapper}>
            <VideoPlayerSection
              videoUrl={url}
              autoPlay={true}
              isControl={true}
            />
          </Box>
        ) : null}
        {imageUrl ? (
          <Box className={classes.container}>
            <Box
              className={classes.imgWrapper}
              sx={{
                height:
                  imgHeight && imgWidth
                    ? (imgHeight / imgWidth) * width
                    : '600px',
                maxHeight: '600px',
              }}
            >
              <Image
                src={imageUrl}
                alt={alt || 'Image'}
                objectFit="contain"
                layout="fill"
              />
            </Box>
            {image_caption ? (
              <Typography variant="body2" textAlign="center" color="cumin.main">
                {image_caption}
              </Typography>
            ) : null}
          </Box>
        ) : null}
      </Container>
    </Box>
  );
};

export default VideoPlayerComponent;
